<div class="w-full max-w-6xl mx-auto space-y-6">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">group</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          User Management
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          View and manage registered users
        </p>
      </div>
    </div>
  </div>

  <!-- TABLE CARD -->
  <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">

    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">

        <!-- Sr No -->
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs text-center w-20 min-w-[80px] px-4 whitespace-nowrap">
            Sr No.
          </th>
          <td mat-cell *matCellDef="let row; let i = index" class="text-sm text-center text-slate-500 font-medium px-4">
            {{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}
          </td>
        </ng-container>

        <!-- Full Name -->
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs tracking-wider px-4 whitespace-nowrap">
            Full Name
          </th>
          <td mat-cell *matCellDef="let u" class="text-sm text-slate-700 px-4 whitespace-nowrap">
            {{ u.fullName }}
          </td>
        </ng-container>

        <!-- Login ID -->
        <ng-container matColumnDef="loginId">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs tracking-wider px-4 whitespace-nowrap">
            Login ID
          </th>
          <td mat-cell *matCellDef="let u" class="text-sm text-slate-600 px-4 whitespace-nowrap">
            {{ u.loginId }}
          </td>
        </ng-container>

        <!-- Role -->
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs tracking-wider px-4 whitespace-nowrap">
            Role
          </th>
          <td mat-cell *matCellDef="let u" class="text-sm text-slate-600 px-4 whitespace-nowrap">
            <span class="px-2 py-1 bg-slate-100 rounded text-xs font-medium border border-slate-200">
              {{ u.roleName }}
            </span>
          </td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs tracking-wider px-4 whitespace-nowrap">
            Email
          </th>
          <td mat-cell *matCellDef="let u" class="text-sm text-slate-600 px-4 whitespace-nowrap">
            {{ u.email }}
          </td>
        </ng-container>

        <!-- Phone -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs tracking-wider px-4 whitespace-nowrap">
            Phone No.
          </th>
          <td mat-cell *matCellDef="let u" class="text-sm text-slate-600 px-4 whitespace-nowrap">
            {{ u.phone || '-' }}
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs text-center tracking-wider px-4">
            Status
          </th>
          <td mat-cell *matCellDef="let u" class="text-center px-4">
            <button (click)="lFN_ChangeUserStatus(u)" class="w-20 text-center px-0 py-1.5 rounded-full
                         text-[10px] font-semibold tracking-widest uppercase
                         transition-all duration-200 border" [ngClass]="u.isActive
                    ? 'bg-emerald-200 text-emerald-900 border-emerald-600 hover:bg-emerald-300'
                    : 'bg-rose-200 text-rose-900 border-rose-600 hover:bg-rose-300'">
              {{ u.isActive ? 'Active' : 'Inactive' }}
            </button>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef
            class="bg-gray-900 text-white uppercase text-xs text-center tracking-wider px-4">
            Actions
          </th>
          <td mat-cell *matCellDef="let u" class="text-center px-4">
            <button mat-icon-button (click)="lFN_EditUser(u)" matTooltip="Edit User"
              class="hover:bg-slate-100 transition-colors">
              <mat-icon class="text-slate-600 text-sm scale-90">edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-0"></tr>

      </table>
    </div>

    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons>
    </mat-paginator>

  </div>
</div>